export default "__VITE_ASSET__CJ$9iVVG__"